/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { Tenant } from './Tenant';
import { TenantPrice } from './TenantPrice';
const ExtendedTenantParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['price', /* #__PURE__ */ parsers.maybeNull(TenantPrice)],
    ['contractStart', parsers.date, 'contract_start'],
]), Tenant);
export class ExtendedTenant extends Tenant {
    static decode(input) {
        return ExtendedTenantParser.decode(input).map(res => new ExtendedTenant(res));
    }
    static unsafeDecode(input) {
        return ExtendedTenant.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExtendedTenantParser.encode(data);
    }
    static schema() {
        return ExtendedTenantParser.schema();
    }
}
